import React, { useState, useEffect, useRef } from 'react';
import Loader from '../../Components/Common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Label, Button } from 'reactstrap';
import { update_bot_details } from '../../slices/thunks';
import { Editor } from '@tinymce/tinymce-react';
import config from '../../config';

function SQL_Instruction() {
  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  const { loading } = useSelector((state) => state.BotDetails);
  const dispatch = useDispatch();

  const [bot_instruction, set_bot_instruction] = useState('');
  const editorRef = useRef(null);

  const {
    Bot_ID,
    User_Role,
    SQL_Instruction: SQL_Instruction_FromStore,
  } = BotDetails || {};

  useEffect(() => {
    set_bot_instruction(SQL_Instruction_FromStore || '');
  }, [SQL_Instruction_FromStore]);

  const onClickSave_BotConfig = () => {
    // If you need PLAIN TEXT instead of HTML, uncomment the next line:
    // const plainText = editorRef.current?.getContent({ format: 'text' }) || '';
    dispatch(
      update_bot_details({
        Bot_ID: Bot_ID,
        SQL_Instruction: bot_instruction, // or plainText if you prefer
      })
    );
  };

  const handle_change = (content/*, editor*/) => {
    set_bot_instruction(content);
  };

  const isReadOnly = User_Role === 'BotUser' || User_Role === 'Viewer';

  return (
    <>
      <div className='mt-5'>
        <div onClick={onClickSave_BotConfig} className="ws-fb" style={{ textAlign: 'right' }}>
        <Button>Save</Button>
      </div>

      <div className="sample_question_wrap border-padding">
        <Row>
          <Col xxl={12} md={12}>
            <div className="mt-3 calc-height">
              <Label htmlFor="type" className="form-label">
                SQL Instruction
              </Label>

              {loading ? (
                <Loader />
              ) : (
                <Editor
                  onInit={(_evt, editor) => (editorRef.current = editor)}
                  apiKey={config.api.tiny_mce_api_key}
                  value={bot_instruction}
                  onEditorChange={handle_change}
                  disabled={isReadOnly}               // role-based lock
                  init={{
                    height: "96%",
                    resize: false,
                    menubar: false,
                    branding: false,                  // hides Tiny logo (cloud free plan allows this)
                    statusbar: true,
                    toolbar_sticky: false,
                    plugins: [
                      'advlist', 'autolink', 'lists', 'link', 'charmap',
                      'preview', 'anchor', 'searchreplace', 'visualblocks',
                      'fullscreen', 'insertdatetime', 'table', 'code', 'wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic underline | ' +
                      'alignleft aligncenter alignright alignjustify | ' +
                      'bullist numlist outdent indent | link table | code | removeformat',
                    content_style:
                      'body { font-family: -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif; font-size:14px }',
                    // Optional: keep it “SQL-instructions friendly”
                    valid_elements: '*[*]',           // allow anything; tighten if needed
                    placeholder: 'Enter your message',
                    // If you want “readonly” mode to still allow text copy:
                    readonly: isReadOnly ? 1 : 0,
                  }}
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
      </div>
    </>
  );
}

export default SQL_Instruction;
